/* eslint-disable react/jsx-props-no-spreading */
import FillInTheBlank from './components/FillInTheBlank/FillInTheBlank';
import { QuestionComponentProps } from './type';
import MultipleChoice from './components/MultipleChoice/MultipleChoice';
import Unscramble from './components/Unscramble/Unscramble';
import TickTF from './components/TickTF/TickTF';
import Combine from './components/Combine/Combine';

const RenderQuestionType = ({ questionData, questionIndex, printMode }: QuestionComponentProps) => {
  const componentType = (questionData.type ?? '').toUpperCase();

  const renderQuestion = () => {
    const data: QuestionComponentProps = {
      questionIndex,
      questionData,
      isCombineChild: false,
      printMode, // truyền flag printMode xuống
    };
    switch (componentType) {
      case 'FILLINTHEBLANK':
        return <FillInTheBlank {...data} />;
      case 'MULTIPLECHOICE':
        return <MultipleChoice {...data} />;
      case 'UNSCRAMBLE':
        return <Unscramble {...data} />;

      case 'TICKTF':
        return <TickTF {...data} />;
      case 'COMBINE':
      case 'COMBINEWITHAUDIO':
      case 'COMBINEWITHVIDEO':
        return <Combine {...data} />;

      default:
        return <></>;
    }
  };

  return <div>{renderQuestion()}</div>;
};

export default RenderQuestionType;
